/**
 * @file   src\pages\NoPage.js
 * @brief  This file is responsible for showing page not found.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
const NoPage = () => {
  return (
    <>
      <h2>404-Page not found</h2>
    </>
  );
};

export default NoPage;
